import { Controller } from "@hotwired/stimulus";
import bootstrap from "bootstrap/dist/js/bootstrap";

export default class extends Controller {
  connect() {
    this.initializeTooltips();
    this.initializePopovers();
    this.initializeToasts();
  }

  initializeTooltips() {
    this.element
      .querySelectorAll("[data-bs-toggle='tooltip']")
      .forEach((tooltip) => {
        const tooltipInstance = bootstrap.Tooltip.getOrCreateInstance(tooltip);
        tooltip.addEventListener("click", () => {
          tooltipInstance.hide();
        });
      });
  }

  initializePopovers() {
    this.element
      .querySelectorAll("[data-bs-toggle='popover']")
      .forEach((popover) => {
        bootstrap.Popover.getOrCreateInstance(popover);
      });
  }

  initializeToasts() {
    this.element
      .querySelectorAll("[data-bs-toggle='toast']")
      .forEach((toast) => {
        bootstrap.Toast.getOrCreateInstance(toast);
      });
  }
}
